import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { filterSetFilters } from 'redux/saga/selectors';
import { SEARCH } from 'constants/filter-sets';
import { deepExtract } from 'helpers/deep';
import { FILTER_NAMES } from '../Search.constants';
import { VerticalsFilter } from '../components/filters/VerticalsFilter';
import { searchFilterActions, selectSelectedVertical } from './filters.helpers';

const { setFilterValue, setFilterEditing } = searchFilterActions;

const { VERTICAL } = FILTER_NAMES;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const { itemsById, orderedItemIds, isEditing } = deepExtract('verticals', filters, {});

  const orderedVerticalOptions = itemsById && orderedItemIds && orderedItemIds.map(itemId => itemsById[itemId]);
  const selectedId = selectSelectedVertical(state);
  const selectedItem =
    orderedVerticalOptions && orderedVerticalOptions.find(verticalOption => verticalOption.id === selectedId);

  return {
    isMobile: selectIsMobile(state),
    items: orderedVerticalOptions || [],
    selectedItemName: selectedItem && selectedItem.name,
    selectedItemId: selectedId,
    isEditing: isEditing || false,
  };
};

export const mapDispatchToProps = {
  onSelect: item =>
    setFilterValue(VERTICAL, item.id, {
      resetIsEditing: true,
    }),
  onSetIsEditing: isEditing => setFilterEditing(VERTICAL, isEditing),
};

const VerticalsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(VerticalsFilter);

export { VerticalsFilterContainer };
